<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="chapter">
<div class="bodymatter" epub:type="bodymatter">
<a id="pagex"></a>
<section epub:type="division">
<div class="dis_img" id="page_x"><img alt="" src="Images/x-1.jpg"/></div>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454932918_epub_fm2_r1.vue?4781ce40